export const AdminRole = [
    { id: 'SUPER_ADMIN', name: 'Super-admin' },
    { id: 'ADMIN', name: 'Admin' },
    { id: 'BILLER', name: 'Biller' },
    { id: 'FACILITY_OWNER', name: 'Facility owner' }
];